import { useEffect, useState } from "react";
import api, { num } from "@/lib/api";
import { Card, PageHeader, StatusBadge, EmptyState, Th, Td } from "@/components/admin/ui";

export default function Leads() {
  const [data, setData] = useState({ items: [], total: 0 });
  useEffect(() => { api.get("/leads?limit=50").then((r) => setData(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6">
      <PageHeader title="Leads" subtitle={`${num(data.total)} leads generated across the workforce`} />
      <Card>
        {data.items.length === 0 ? <EmptyState title="No leads yet" desc="Leads created by workers will appear here." /> : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="border-b border-white/10"><tr><Th>Lead ID</Th><Th>Company</Th><Th>Contact</Th><Th>Industry</Th><Th>Worker</Th><Th>Status</Th></tr></thead>
              <tbody>
                {data.items.map((l) => (
                  <tr key={l.id} className="border-b border-white/5 hover:bg-white/[0.02]" data-testid={`lead-row-${l.lead_id}`}>
                    <Td className="font-mono-metric text-[#1D4ED8]">{l.lead_id}</Td>
                    <Td className="text-white font-medium">{l.company}</Td>
                    <Td className="text-slate-400">{l.contact_name || "—"}</Td>
                    <Td className="text-slate-400">{l.industry || "—"}</Td>
                    <Td className="text-slate-400">{l.worker_id}</Td>
                    <Td><StatusBadge status={l.status} /></Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
